const SubmitSuccess = ({ setStep }: { setStep: (step: number) => void }) => {
  return (
    <section className="bg-gray-7 dark:bg-gray-7 flex flex-col justify-center items-center h-full text-white text-center pt-[40px] pb-[40px] px-6">
      <h2 className="text-center max-w-[345x] md:max-w-[688px] font-[900] md:font-extrabold text-[32px] md:text-[50px] leading-[38px] md:leading-[52px] mb-[17px] md:mb-[75px]">
        Thank you for submitting your report!
      </h2>

      <p className="max-w-[247px] md:max-w-[688px] font-normal text-sm md:text-base leading-[18px] md:leading-5 mb-[25px] md:mb-[56px]">
        Our specialists are always aware of your case and ready to help you at
        any time.
      </p>

      <div className="flex flex-col gap-5 md:gap-6 w-full items-center">
        <button
          className="font-extrabold text-base md:text-[18px] leading-5 md:leading-[22px] w-full md:w-[300px] bg-white text-gray-7 py-[11px] md:py-[15px] rounded-3xl"
          onClick={() => setStep(12)}
        >
          View Report
        </button>
        <a className="text-[18px] leading-[22px] font-[900]" href="/">
          Return to Home
        </a>
      </div>
    </section>
  );
};

export default SubmitSuccess;
